<template>
  <div class="cancel-subscription" :class="['step-' + step, animation]">
    <div class="close-button" @click="close">
      <i class="la la-times"></i>
    </div>

    <!-- <div style="position: absolute; display: inline-flex; z-index: 3; left: 20px; top: 20px">
      <button class="btn btn-primary" @click="goNext('hey')">Hey</button>
      <button class="btn btn-primary" @click="goNext('reason')">Reason</button>
      <button class="btn btn-primary" @click="goNext('understand')">Understand</button>
      <button class="btn btn-primary" @click="goNext('offer')">Offer</button>
      <button class="btn btn-danger" @click="goNext('warning')">Warning</button>
      <button class="btn btn-primary" @click="goNext('canceled')">Canceled</button>
    </div> -->

    <div class="warning-bg"></div>

    <!-- Hey buddy -->
    <perfect-scrollbar class="wrapper align-center" :class="animation_hey">
      <div style="height: 12vh"></div>
      <img src="@/assets/img/logo-weezly.png" alt="WEEZLY" height="110px" />
      <div style="height: 3vh"></div>
      <h1 class="strong mb-15 font-h2-xs" style="font-size: 64px">Hey {{ me.userName }} 👋</h1>
      <h3 class="font-h5-xs" v-if="!is_delete_account">Would you like to cancel your Weezly {{ plan_name }}?</h3>
      <h3 class="font-h5-xs" v-else>Would you like to delete your account cancel your Weezly {{ plan_name }}?</h3>
      <div class="p-20"></div>
      <button class="btn btn-primary free-width free-height font-h3 px-30 py-15" style="min-width: 250px" @click="close">No, thanks</button>
      <div class="m-30">
        <span class="font-h6 inline-block pointer color-hover-primary" @click="goNext('reason')">Proceed</span>
      </div>
    </perfect-scrollbar>

    <!-- What is the reason -->
    <perfect-scrollbar class="wrapper align-center" :class="animation_reason">
      <div style="height: 12vh"></div>
      <img src="@/assets/img/logo-weezly.png" alt="WEEZLY" height="110px" />
      <div style="height: 3vh"></div>
      <h1 class="strong font-h2-xs" style="font-size: 64px">What is the main reason you're canceling?</h1>
      <div class="p-20">
        <div class="textarea-placeholder align-left inline-block max-full-width" @click="$refs.textarea.focus()">
          <textarea
            maxlength="500"
            v-model="reason"
            class="max-full-width font-h5"
            :class="{ error: reason_error }"
            ref="textarea"
            @input="reason_error = ''"
            style="width: 780px; height: 200px"
            data-placeholder=""></textarea>
          <div class="the-placeholder" :class="{ hide: reason }">
            <h6>Please tell us, why are you cancelling your subscription?</h6>
            <h6>What didn't work out for you?</h6>
          </div>
        </div>
        <p v-if="reason_error" class="color-danger">{{ reason_error }}</p>
      </div>
      <br />
      <button class="btn btn-primary free-width free-height font-h3 px-30 py-15" style="min-width: 250px" @click="close">Cancel</button>
      <div class="m-30">
        <span class="font-h6 inline-block pointer color-hover-primary" @click="reasonNext">Proceed</span>
      </div>
    </perfect-scrollbar>

    <!-- Did you understand Weezly -->
    <perfect-scrollbar class="wrapper flex flex-column" :class="animation_understand">
      <div class="flex-1"></div>
      <div class="flex p-20 margin-auto max-full-width block-xs" style="width: 1800px">
        <div class="flex-1 pr-30 align-center-xs pr-0-xs">
          <img src="@/assets/img/logo-weezly.png" alt="WEEZLY" height="110px" />
          <h1 class="strong font-h2-xs" style="font-size: 64px">
            Did you understand<br />
            Weezly?
          </h1>
          <h3 class="font-h5-xs">
            Since you are
            <span v-if="!is_delete_account">cancelling your {{ me.plan_type.endsWith("trial") ? "trial" : "subscription" }}</span>
            <span v-else>deleting your account</span> it seems that you have not understood how Weezly is working and what value it gives you.
          </h3>
          <h3>We can arrange personal onboarding of the tool. <br />Let's book a quick on the right side.</h3>
        </div>
        <!-- Weezly inline widget begin -->
        <div style="width: 55%; min-width: calc(min(100%, 700px))" class="max-full-width">
          <iframe
            src="https://weezly.com/mensur/how-can-weezly-help-to-grow-your-business"
            style="min-width: calc(min(100%, 600px)); width: 100%; min-height: 600px; border: 0"
            class="border-radius block max-full-width"></iframe>
          <br />
          <span class="font-h6 inline-block pointer color-hover-primary ml-30" @click="understandNext">No thanks, proceed.</span>
        </div>
        <!-- Weezly inline widget end -->
      </div>
      <div class="flex-1"></div>
    </perfect-scrollbar>

    <!-- Offer for you -->
    <perfect-scrollbar class="wrapper align-center" :class="animation_offer">
      <div style="height: 12vh"></div>
      <img src="@/assets/img/logo-weezly.png" alt="WEEZLY" height="110px" />
      <div style="height: 3vh"></div>

      <div v-if="claimed">
        <h1 class="strong font-h2-xs" style="font-size: 64px">Your offer has been claimed</h1>
        <div class="px-20 mb-20">
          <div class="border-radius offer-claimed max-full-width bg-darkorange margin-auto align-center p-30" style="width: 1040px">
            <br /><br />
            <h3 class="mb-20 strong">Congratulations!</h3>
            <h3>The discount of 50% have been applied <br />to your account for next 3 months!</h3>
            <br /><br />
          </div>
        </div>
        <br />
        <button class="btn btn-primary free-width free-height font-h3 px-30 py-15" style="min-width: 250px" @click="close">Close</button>
      </div>
      <div v-else>
        <h1 class="strong font-h2-xs" style="font-size: 64px">Special offer for you {{ me.userName }}</h1>
        <div class="px-20 mb-20">
          <div class="flex border-radius hot-sale items-center max-full-width bg-darkorange margin-auto align-left p-30 p-0-xs" style="width: 1040px">
            <div class="flex-1 p-20">
              <h3 class="mb-5 font-h5-xs">We'd hate to lose you.</h3>
              <h3 class="font-h5-xs">Stay to get <strong>50% off</strong> for 3 months!</h3>
              <br /><br />
              <div v-if="billing.subscription.price">
                <h3 class="inline-block mr-30 font-h5-xs">
                  <span class="line-through">Next payment: ${{ billing.subscription.price }} / month</span>
                </h3>
                <h2 class="inline-block font-h5-xs">
                  <span class="strong">Now only: ${{ Math.floor(billing.subscription.price / 2) }}</span>
                </h2>
              </div>
            </div>
            <div class="hide-xs">
              <img src="@/assets/img/icons/hot-sale.png" alt="Offer" height="200px" />
            </div>
          </div>
        </div>
        <br />

        <button class="btn btn-primary free-width free-height font-h3 px-30 py-15" style="min-width: 250px" @click="claimOffer">
          Claim the offer <i v-if="loading" class="la la-spinner spinning ml-5"></i>
        </button>
        <div class="m-30" v-if="!loading">
          <span class="font-h6 inline-block pointer color-hover-primary" @click="goNext('warning')">No thanks, proceed.</span>
        </div>
      </div>
    </perfect-scrollbar>

    <!-- Warning -->
    <perfect-scrollbar class="wrapper align-center" :class="animation_warning">
      <div style="height: 12vh"></div>
      <img src="@/assets/img/logo-weezly.png" alt="WEEZLY" height="110px" />
      <div style="height: 3vh"></div>
      <h1 class="strong font-h2-xs" style="font-size: 64px">Warning! Everything will be lost!</h1>
      <div class="px-20">
        <div class="inline-block marign-auto align-left font-h5">
          <div class="warning-list">
            <span class="warning-icon mr-10"><i class="la la-times"></i></span>
            <span>You will loose all your data</span>
          </div>
          <div class="warning-list">
            <span class="warning-icon mr-10"><i class="la la-times"></i></span>
            <span>You will loose all your settings and customizations</span>
          </div>
          <div class="warning-list">
            <span class="warning-icon mr-10"><i class="la la-times"></i></span>
            <span>You will loose all your videos</span>
          </div>
          <div class="warning-list">
            <span class="warning-icon mr-10"><i class="la la-times"></i></span>
            <span>You will loose all your booking pages & events</span>
          </div>
          <div class="warning-list">
            <span class="warning-icon mr-10"><i class="la la-times"></i></span>
            <span>You will loose all campaigns</span>
          </div>
        </div>
      </div>
      <br /><br />
      <button class="btn btn-danger free-width free-height font-h3 px-30 py-15 no-border" style="min-width: 250px; background-color: #d10015" @click="close">
        Cancel
      </button>
      <div class="m-30">
        <span class="font-h6 inline-block pointer color-hover-primary" @click="cancelSubscription">Proceed</span>
      </div>

      <div class="absolute-inside overlay flex items-center justify-center" v-if="loading" style="backdrop-filter: blur(10px)">
        <div class="align-center">
          <Loading />
          <h5 class="strong my-20">Please wait, it may take a while...</h5>
        </div>
      </div>
    </perfect-scrollbar>

    <!-- Subscription have been canceled -->
    <perfect-scrollbar class="wrapper align-center" :class="animation_canceled">
      <div style="height: 12vh"></div>
      <img src="@/assets/img/logo-weezly.png" alt="WEEZLY" height="110px" />
      <div style="height: 3vh"></div>
      <h1 v-if="!is_delete_account" class="strong font-h2-xs" style="font-size: 64px">Your Weezly subscription<br />have been canceled.</h1>
      <h1 v-else class="strong" style="font-size: 64px">Your Weezly account<br />have been deleted.</h1>
      <br /><br />

      <div v-if="!is_delete_account">
        <h5 class="font-h5s" v-if="billing.expiring">
          Your current subscription is valid until {{ moment(billing.expiring.sub_end, "X").format("DD MMMM, YYYY") }}
        </h5>
        <h5 class="font-h5s" v-else-if="me.plan_type.endsWith('_trial')">
          Your current subscription is valid until {{ moment(me.trial_end, "X").format("DD MMMM YYYY") }}
        </h5>

        <br /><br /><br />
        <button class="btn btn-primary free-width free-height font-h3 px-30 py-15" style="min-width: 250px" @click="close">Close the window</button>
      </div>
    </perfect-scrollbar>
  </div>
</template>

<script>
import request from "@/service";
import types from "@/constants/types";
import moment from "moment";
export default {
  name: "CancelSubscription",
  components: {},
  props: {
    billing: {
      type: Object,
      required: true,
      default: {},
    },
    is_delete_account: {
      default: false,
      type: Boolean,
    },
  },
  data: function () {
    return {
      animation: "animated zoomIn faster",
      step: "hey",
      animation_hey: "",
      animation_reason: "hide",
      animation_understand: "hide",
      animation_offer: "hide",
      animation_warning: "hide",
      animation_canceled: "hide",
      reason: "",
      reason_error: "",
      moment: moment,
      loading: false,
      claimed: false,
    };
  },
  computed: {
    me() {
      return this.$store.getters.getMe;
    },
    plan_name() {
      let plan = this.me.plan_type.replace("_", " ");
      return plan.charAt(0).toUpperCase() + plan.slice(1);
    },
  },
  async mounted() {
    setTimeout(() => {
      this.animation = "";
    }, 500);
  },
  methods: {
    async wait(ms) {
      return new Promise((res) => setTimeout(res, ms));
    },
    async goPrev(n) {
      let o = this.step;
      this[`animation_${o}`] = "animated fadeOutRight faster";
      this[`animation_${n}`] = "animated fadeInLeft faster";

      this.step = n;

      await this.wait(500);

      this[`animation_${o}`] = "hide";
      this[`animation_${n}`] = "";
    },
    async goNext(n) {
      let o = this.step;

      this[`animation_${o}`] = "animated fadeOutLeft faster";
      this[`animation_${n}`] = "animated fadeInRight faster";

      this.step = n;

      await this.wait(500);
      this[`animation_${o}`] = "hide";
      this[`animation_${n}`] = "";
    },
    close() {
      if (this.loading) return;
      this.animation = "animated zoomOut faster";
      setTimeout(() => {
        this.$emit("close");
        this.animation = "hide";
      }, 500);
    },

    reasonNext() {
      if (this.reason.length < 20) {
        this.reason_error = "Please enter at least 20 characters.";
        this.$refs.textarea.focus();
      } else {
        this.goNext("understand");
      }
    },
    understandNext() {
      if (this.billing.subscription.coupon) this.goNext("warning");
      else if (this.me.plan_type.startsWith("growth")) this.goNext("offer");
      else this.goNext("warning");
    },
    async claimOffer() {
      if (this.loading) return false;

      this.loading = true;
      let claim_offer = await request("POST", "stripe/claimOffer");
      if (!claim_offer) {
        this.$root.$emit("alert", "Sorry! We cannot apply a coupon to your plan.", "error");
      } else {
        this.claimed = true;
        this.$emit("updated");
      }
      this.loading = false;
    },
    async cancelSubscription() {
      this.loading = true;

      let reason = this.reason.trim();
      const unsubscribe = await request("POST", "stripe/unsubscribe", {
        reason: reason,
      });

      if (unsubscribe) {
        this.$emit("updated");
        await this.$store.dispatch({
          type: types.getMeInfo,
        });
        if (!this.is_delete_account) {
          this.goNext("canceled");
        } else {
          // DELETE ACCOUNT
          const response = await request("POST", "users/delete", {
            reason: reason,
            pass: "DeleteAfterCancelSubscription",
          });

          if (!response) {
            this.$root.$emit("alert", "We could not delete your account. Please try again!", "error");
            this.loading = false;
            this.close();
          } else {
            this.goNext("canceled");
            setTimeout(() => {
              var referrer = window.localStorage.getItem("referrer");
              var language = window.localStorage.getItem("language");
              var theme = window.localStorage.getItem("theme");
              var show_preview_menu = window.localStorage.getItem("show_preview_menu");

              window.localStorage.clear();
              sessionStorage.clear();
              Cookies.remove("me");
              Cookies.remove("id");
              Cookies.remove("vuex");
              Cookies.remove("token");

              if (typeof referrer != "undefined" && referrer != null) {
                window.localStorage.setItem("referrer", referrer);
              }

              if (typeof language != "undefined" && language != null) {
                window.localStorage.setItem("language", language);
              }

              if (typeof theme != "undefined" && theme != null) {
                window.localStorage.setItem("theme", theme);
              }

              if (typeof show_preview_menu != "undefined" && show_preview_menu != null) {
                window.localStorage.setItem("show_preview_menu", show_preview_menu);
              }

              this.$store.dispatch({
                type: type.logout,
              });
              this.loading = false;
              this.$router.push("/login");
            }, 3000);
          }
        }
      } else {
        this.$root.$emit("alert", this.$t("alert.something_wrong"), "error");
      }
      this.loading = false;
    },
  },
};
</script>
